/**
 * Custom hook for moderation API operations
 * Centralizes all API calls with proper authentication
 */
import {
  ModerationResource,
  ModerationConfig,
  ModerationConfigResponse,
  BlocklistItem,
  ModerationAction,
} from "../../../api/moderation";

export const useModerationApi = () => {
  // Moderation Flags
  const refreshFlags = (params?: {
    meetingId?: string;
    action?: ModerationAction;
    limit?: number;
    nextToken?: string;
  }) => {
    return ModerationResource.getFlags(params);
  };

  // Configuration
  const refreshConfig = () => {
    return ModerationResource.getConfig();
  };

  const getConfig = async (): Promise<ModerationConfigResponse> => {
    return ModerationResource.getConfig();
  };

  const updateConfig = async (config: ModerationConfig) => {
    return ModerationResource.updateConfig(config);
  };

  // Blocklist
  const refreshBlocklist = () => {
    return ModerationResource.getBlocklist();
  };

  const addBlocklistItem = async (item: BlocklistItem) => {
    return ModerationResource.addBlocklistItem(item);
  };

  const deleteBlocklistItem = async (item: BlocklistItem) => {
    return ModerationResource.deleteBlocklistItem(item);
  };

  // Allowlist
  const refreshAllowlist = () => {
    return ModerationResource.getAllowlist();
  };

  const addAllowlistWord = async (value: string) => {
    return ModerationResource.addAllowlistWord(value);
  };

  const deleteAllowlistWord = async (value: string) => {
    return ModerationResource.deleteAllowlistWord(value);
  };

  return {
    // Flags
    refreshFlags,

    // Config
    refreshConfig,
    getConfig,
    updateConfig,

    // Blocklist
    refreshBlocklist,
    addBlocklistItem,
    deleteBlocklistItem,

    // Allowlist
    refreshAllowlist,
    addAllowlistWord,
    deleteAllowlistWord,
  };
};
